import { health_saarthi, members } from "../../js/path";
import _ from "lodash";

export default {
  data() {
    return {
      tableData: {
        data: [],
        total: 0,
        count: 0,
        per_page: 10,
        current_page: 1,
        total_pages: 1,
      },

      fields: [
        { key: "doctor_code", label: "Doctor Code" },
        { key: "doctor_name", label: "Doctor" },
        { key: "contact", label: "Contact" },
        { key: "patient_count", label: "Patients", sortable: true },
        { key: "diet_plan_count", label: "Diet Plans", sortable: true },
      ],

      currentPage: 1,
      filter: "",
      pageNo: null,

      // Add Doctor Code modal
      doctorCodeModal: false,
      submitted: false,
      memberList: [],
      doctorCodeForm: {
        member_id: null,
        doctor_code: "MED",
      },
    };
  },

  computed: {
    // Valid only when it's "MED" + exactly 3 alphanumeric chars (6 total)
    isDoctorCodeValid() {
      return /^MED[A-Z0-9]{3}$/.test(this.doctorCodeForm.doctor_code || "");
    },
  },

  methods: {
    // Main API call
    async fetchData() {
      let url =
        health_saarthi.healthSaarthiDetailsUrl + `?page=${this.currentPage}&size=20`;

      if (this.filter) {
        url += `&search=${this.filter}`;
      }

      this.updateUrl();

      this.$store.commit("loader/updateStatus", true);

      try {
        const res = await this.getRequest(url);

        if (res.status) {
          this.tableData = res.response;
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err?.data?.message || "Something went wrong",
        });
      }

      this.$store.commit("loader/updateStatus", false);
    },

    // Search button
    searchFor() {
      this.currentPage = 1;
      this.fetchData();
    },

    // Enter to search (clearing is handled by the filter watcher)
    search(event) {
      if (event.keyCode === 13) {
        this.currentPage = 1;
        this.fetchData();
      }
    },

    // Open the Add Doctor Code modal
    openDoctorCodeModal() {
      this.doctorCodeModal = true;
    },

    // Keep the "MED" prefix locked and cap the code at 6 chars (MED + 3)
    formatDoctorCode(value) {
      const code = (value || "").toUpperCase();

      // Block editing into the locked "MED" prefix
      if (!code.startsWith("MED")) {
        this.doctorCodeForm.doctor_code = "MED";
        return;
      }

      const suffix = code.slice(3).replace(/[^A-Z0-9]/g, "").slice(0, 3);
      this.doctorCodeForm.doctor_code = "MED" + suffix;
    },

    // Reset the modal form when it closes
    clearDoctorCodeForm() {
      this.submitted = false;
      this.memberList = [];
      this.doctorCodeForm = { member_id: null, doctor_code: "MED" };
    },

    // Debounced member search for the modal dropdown
    fetchMemberList: _.debounce(async function (query) {
      this.memberList = [];

      if (!query || query.trim() === "") return;

      this.$store.commit("loader/updateStatus", true);

      try {
        const res = await this.getRequest(
          members.getMembers + `?search=${query}`
        );

        const list = res?.response?.data || res?.data || [];

        this.memberList = list.map((member) => ({
          member_id: member.id,
          fnameAndLname: `${member.fname} ${member.lname} - ${member.mobile_number}`,
        }));
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err?.data?.message || "Something went wrong",
        });
      } finally {
        this.$store.commit("loader/updateStatus", false);
      }
    }, 1000),

    // Submit a new doctor code
    async addDoctorCode() {
      this.submitted = true;

      if (
        !this.doctorCodeForm.member_id ||
        !this.isDoctorCodeValid
      )
        return;

      this.$store.commit("loader/updateStatus", true);

      try {
        const res = await this.postRequest(health_saarthi.addDoctorCodeUrl, {
          member_id: this.doctorCodeForm.member_id.member_id,
          doctor_code: this.doctorCodeForm.doctor_code,
        });

        if (res.status) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: res?.message || "Doctor code added successfully",
          });
          this.doctorCodeModal = false;
          this.currentPage = 1;
          this.fetchData();
        } else {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: res?.message || "Something went wrong",
          });
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err?.data?.message || "Something went wrong",
        });
      }

      this.$store.commit("loader/updateStatus", false);
    },

    // Manual page input
    filterPage() {
      if (this.pageNo && this.pageNo > 0) {
        this.currentPage = Number(this.pageNo);
        this.fetchData();
      }
    },

    // Keep the browser URL in sync with the current search/page
    updateUrl() {
      const url = new URL(window.location);

      if (this.filter) url.searchParams.set("search", this.filter);
      else url.searchParams.delete("search");

      url.searchParams.set("page", this.currentPage);

      history.pushState({}, "", url);
    },
  },

  watch: {
    currentPage(val) {
      if (val) this.fetchData();
    },
    filter(val) {
      if (!val) {
        this.currentPage = 1;
        this.fetchData();
      }
    },
  },

  created() {
    if (this.$route.query.search) {
      this.filter = this.$route.query.search;
    }

    if (this.$route.query.page) {
      this.currentPage = Number(this.$route.query.page);
    }

    this.fetchData();
  },
};
